<template>
    <div>
      <b-card-body>
        <b-card class="importContainer">
          <b-form-group :label="$t('escolha-orange')">
            <ul class="option-list">
              <li
                v-for="(option, idx) in orangeOptions"
                :key="'opt-' + idx"
                class="clickable-item"
                @click="selectOption(option)"
              >
                {{ option }}
              </li>
            </ul>
          </b-form-group>
          <b-row class="groupBtn">
            <div class="modal-buttons">
              <img
                class="action-btn ml-2 exit-btn"
                width="30"
                height="30"
                src="@/assets/sair.png"
                :title="$t('cancelar')"
                @click="onClose"
              />
            </div>
          </b-row>
        </b-card>
      </b-card-body>
    </div>
  </template>
  
  <script>
  export default {
    name: "OrangeOptModal",
    props: {
      orangeOptions: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      selectOption(option) {
        this.$emit("select", option);
      },
      onClose() {
        this.$emit("close");
      }
    }
  };
  </script>
  
  <style scoped>
  .importContainer {
    max-width: 400px;
  }
  
  .modal-title {
    text-align: center;
    margin-bottom: 15px;
    font-size: 18px;
  }
  
  /* Lista de opções */
  .option-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .clickable-item {
    cursor: pointer;
    padding: 8px 5px;
    border-bottom: 1px solid #ccc;
    font-size: 16px;
  }
  
  .clickable-item:hover {
    background-color: #f2f2f2;
  }
  
  .groupBtn {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  
  .modal-buttons {
    text-align: right;
    cursor: pointer;
  }
  
  .action-btn {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .exit-btn {
    margin-left: 14px;
    margin-right: 14px;
  }

  .cursor {
    cursor: pointer;
  }
  </style>
  